export type SingleDigit = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';

export type EmptyPinEntryField = '';

export type PinCodePattern = `${SingleDigit}${SingleDigit}${SingleDigit}${SingleDigit}`;

export type PinIndex = 0 | 1 | 2 | 3;

export type PinEntryField = SingleDigit | EmptyPinEntryField;

export type PinEntryFields = [PinEntryField, PinEntryField, PinEntryField, PinEntryField];

export type PinEntryFieldsFourDigits = [SingleDigit, SingleDigit, SingleDigit, SingleDigit];

export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export const EMPTY_PIN_ENTRY_FIELD: EmptyPinEntryField = '';
